import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router";

import { Center, LoadingIndicator } from "@/components";

import { TaggableUsersProvider } from "@/contexts/TaggableUsersContext";
import { storage } from "@/lib/storage";

export const MobileLayout = () => {
  /* Misc Hooks */
  const navigate = useNavigate();

  /* React Hooks */
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const user = storage.getUser();
    if (!user) {
      void navigate("/sign-in");
      return;
    }
    setIsAuthenticated(true);
  }, [navigate]);

  /* Render */
  const render = () => {
    if (!isAuthenticated) {
      return (
        <Center className="h-svh bg-slate-50">
          <LoadingIndicator variant="xlarge" />
        </Center>
      );
    }

    return (
      <TaggableUsersProvider>
        <main className="mx-auto min-h-svh w-full max-w-lg bg-slate-50">
          <Outlet />
        </main>
      </TaggableUsersProvider>
    );
  };

  return render();
};
